// extracted by mini-css-extract-plugin
export var largelink = "style-module--largelink--1msiF";
export var largelink_arrow = "style-module--largelink_arrow--3QtD-";
export var largelink_l = "style-module--largelink_l--JLJ4o";
export var largelink_r = "style-module--largelink_r--10RAT";
export var largelink_title = "style-module--largelink_title--1X6be";